export default __webpack_public_path__ + "static/media/chatbot.3aaa19e1.jpg";